exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "section.Actions {\n  -webkit-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s; }\n  section.Actions.Hide {\n    opacity: 0;\n    -webkit-transform: translateY(20vh);\n        -ms-transform: translateY(20vh);\n            transform: translateY(20vh); }\n  section.Actions .Button + .Button {\n    margin-left: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Actions/SectionActions.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Actions/SectionActions.css
// module chunks = 0